module.exports = __webpack_public_path__ + "static/media/21_plantilla_rec_combo_simple_cp_stills_pet_591_sw_sin_gas.8293cb19.png";